import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a9a87e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-image" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "countdown" }

import { onMounted, PropType, ref, onBeforeUnmount } from 'vue'
import { Player } from '@/model/Player'
import { JourneyData } from '@/model/Journey'
import { dateToCountdown } from '@/common/Utils'
import { DigInputController } from '@digithia/input/common'
import { Toaster } from '@/common/Toaster'
import { __ } from '@/locales'

import GameImage from '@/components/game/basics/GameImage.vue'
import GameTitle from '@/components/game/basics/GameTitle.vue'
import GameText from '@/components/game/basics/GameText.vue'
import GameButton from '@/components/game/basics/GameButton.vue'
import GameSelect from '@/components/game/basics/GameSelect.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePlayerCreated',
  props: {
  player: {
    type: Object as PropType<Player>,
    required: true,
  },
  journey: {
    type: Object as PropType<JourneyData>,
    required: true,
  },
  projectImage: { type: String as PropType<string | undefined>, default: '' },
  loadingStart: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["start"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'start', alternative: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const alternative = ref<boolean | undefined>(undefined)
const countdownCreate = ref<string | undefined>(undefined)
const REFRESH_TIME_INTERVAL = 1000
const interval = ref<NodeJS.Timer | undefined>(undefined)

onMounted(() => {
  countdownCreate.value = computeCountdownStarted()

  interval.value = setInterval(() => {
    countdownCreate.value = computeCountdownStarted()
  }, REFRESH_TIME_INTERVAL)
})

onBeforeUnmount(() => {
  clearInterval(interval.value)
})

const computeCountdownStarted = () => {
  return dateToCountdown(
    props.player.createdAt,
    props.journey.expirationDurationSecond || 0,
    'second',
  )
}

const start = async () => {
  if (!DigInputController.checkInputsValidity('.form-alternative')) {
    return Toaster.toast({ message: __('invalidForm'), type: 'warning' })
  }

  emits('start', !!alternative.value)
}

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_loader = _resolveComponent("dig-ui-loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(GameImage, { base64: __props.projectImage }, null, 8, ["base64"])
    ]),
    _createVNode(GameTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.welcome', {
          name: `${__props.player.firstname} ${__props.player.lastname}`,
        })), 1)
      ]),
      _: 1
    }),
    (__props.journey.hasAlternative)
      ? (_openBlock(), _createBlock(GameSelect, {
          key: 0,
          value: alternative.value,
          onSelect: _cache[0] || (_cache[0] = ($event: any) => (alternative.value = $event))
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.completedOtherJourney')), 1)
          ]),
          selectFalse: _withCtx(() => [
            _createTextVNode(" - " + _toDisplayString(_ctx.$t('OtherJourney.first')), 1)
          ]),
          selectTrue: _withCtx(() => [
            _createTextVNode(" - " + _toDisplayString(_ctx.$t('OtherJourney.done')), 1)
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (alternative.value !== undefined || !__props.journey.hasAlternative)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GameText, null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: __props.journey.start
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            (!__props.loadingStart)
              ? (_openBlock(), _createBlock(GameButton, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (start()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.start')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.loadingStart)
              ? (_openBlock(), _createBlock(_component_dig_ui_loader, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('View.Player.Start.timerStart', {
          countdown: countdownCreate.value,
        })), 1)
  ]))
}
}

})